module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-24-min.f6850aae.jpg";